// File: `app/javascript/controllers/product_module/accessible_tourism.js`
import $ from 'jquery';
import flatpickr from 'flatpickr';
import {withElementBlock} from "../blockUI_controller";

export function initAccessibleTourism(deps = {}) {
    const {
        form_type_send,
        create_array_for_product,
        get_contract,
        modality_info,
        pick_up_location_info,
        setSessionVar,
        showMapModal,
        showDescriptionModal,
        date_disabled,
        flatpick_lang,
        I18n,
        location,
        sessionStorage
    } = deps;

    if (!form_type_send) return;

    // Selectores
    const accessible_tourism_to = $('#accessible_tourism_to');
    const accessible_tourism_service = $('#accessible_tourism_service');
    const accessible_tourism_modality = $('#accessible_tourism_modality');
    const accessible_tourism_pick_up_location = $('#accessible_tourism_pick_up_location');
    const accessible_tpul_btn = $('#accessible_tpul_btn');
    const accessible_tourism_date = $('#accessible_tourism_date');
    const accessible_tourism_cantidad = $('#accessible_tourism_cantidad');
    const accessible_tourism_observaciones = $('#accessible_tourism_observaciones');
    const accessible_tourism_btn_info = $('#accessible_tourism_btn_info');
    let accessible_tourism_btn_info_desc = '';

    // Estado inicial
    accessible_tourism_service.prop('disabled', true).select2({ theme: 'bootstrap', placeholder: I18n.t('global.main.form.select_service') });
    accessible_tourism_modality.prop('disabled', true).select2({ theme: 'bootstrap', placeholder: I18n.t('global.main.form.select_modality') });
    accessible_tourism_pick_up_location.prop('disabled', true).select2({ theme: 'bootstrap', placeholder: I18n.t('global.main.form.select_pick_up_location') });
    accessible_tourism_date.prop('disabled', true);
    accessible_tourism_cantidad.prop('disabled', true);
    accessible_tourism_observaciones.prop('disabled', true);

    // Destinos
    accessible_tourism_to.select2({
        theme: "bootstrap",
        placeholder: I18n.t('global.main.form.select_destiny'),
        ajax: {
            url: '/destination',
            dataType: "json",
            language: "es",
            data: function (params) {
                return {
                    form_type: form_type_send.val(),
                    search: params.term,
                    page: params.page || 1
                };
            },
            type: 'GET',
            processResults: function (data, params) {
                params.page = params.page || 1;
                const result = (data.rows || []).map(elem => ({
                    id: `${elem.code}|${elem.id}|${elem.name}`,
                    text: elem.name
                }));
                const total = data.total || 0;
                return {
                    results: result,
                    pagination: { more: total > 10 && ((parseInt(total) - (10 * parseInt(params.page || 1))) > 1) }
                };
            }
        }
    }).on('change', function (e) {
        accessible_tpul_btn[0].classList.add('ocultar');

        const parts = (e.target.value || '').split('|');
        const destino_id = parts[1] || '';
        create_array_for_product('product_type', form_type_send.val());
        create_array_for_product('destination_id', destino_id);
        create_array_for_product('destination_code', parts[0] || '');
        create_array_for_product('text_destination', parts[2] || '');

        // limpiar y reset
        accessible_tourism_service.empty();
        accessible_tourism_modality.empty();
        accessible_tourism_pick_up_location.empty();
        accessible_tourism_date.val('');
        accessible_tourism_cantidad.val('');
        accessible_tourism_observaciones.val('');
        accessible_tourism_btn_info[0].classList.add('ocultar');
        accessible_tourism_btn_info_desc = '';

        // Servicios por dealer
        accessible_tourism_service.prop('disabled', false).select2({
            theme: "bootstrap",
            placeholder: I18n.t('global.main.form.select_service'),
            ajax: {
                url: `${location.origin}/${sessionStorage.getItem('locale')}/service_by_dealer`,
                data: function (params) {
                    return {
                        search: params.term,
                        page: params.page || 1,
                        destination: destino_id,
                        form_type: form_type_send.val()
                    };
                },
                type: 'GET',
                processResults: function (data, params) {
                    params.page = params.page || 1;
                    const result = (data.services || []).map(elem => ({
                        id: `${elem.id}|${elem.code}|${elem.reservation_time}|${data.dealer_code}|${data.dealer_name}|${data.dealer_id}|${elem.min_reservation_amount}|${elem.max_reservation_amount}`,
                        text: elem.name
                    }));
                    const total = data.total || 0;
                    return {
                        results: result,
                        pagination: { more: total > 10 && ((parseInt(total) - (10 * parseInt(params.page || 1))) > 1) }
                    };
                }
            }
        }).on('change', function (e) {
            accessible_tourism_pick_up_location.prop('disabled', false);
            accessible_tourism_date.prop('disabled', false);
            accessible_tourism_cantidad.prop('disabled', false);
            accessible_tourism_observaciones.prop('disabled', false);
            accessible_tourism_btn_info[0].classList.add('ocultar');
            accessible_tourism_btn_info_desc = '';

            const product_type = (e.target.value || '').split("|");
            const reservation_offset = parseInt(product_type[2] || 0);

            create_array_for_product('category_id', product_type[0]);
            create_array_for_product('category_code', product_type[1]);
            create_array_for_product('dealer_code', product_type[3]);
            create_array_for_product('dealer_name', product_type[4]);
            create_array_for_product('dealer_id', product_type[5]);

            // FIX (2026-08-10): contrato con bloqueo + desbloqueo garantizado.
            withElementBlock('box-form', I18n.t('global.main.form.message.search_contract'), get_contract('box-form')).then(gcontract => {
                if (!gcontract.next) return;
            });

            // Modalidades
            let modality_selected = '';
            accessible_tourism_modality.prop('disabled', false).select2({
                theme: "bootstrap",
                placeholder: I18n.t('global.main.form.select_modality'),
                ajax: {
                    url: `${location.origin}/${sessionStorage.getItem('locale')}/modalities`,
                    dataType: "json",
                    language: "es",
                    data: function (params) {
                        return {
                            search: params.term,
                            product: product_type[0],
                            dealer: product_type[5]
                        };
                    },
                    type: 'GET',
                    processResults: function (data) {
                        const result = (data.rows || []).map(elem => ({ id: elem, text: elem }));
                        return { results: result };
                    }
                }
            }).on('change', function (ev) {
                modality_selected = ev.target.value;
                accessible_tpul_btn[0].classList.add('ocultar');
                accessible_tourism_pick_up_location.empty();
                accessible_tourism_pick_up_location.prop('disabled', false);
                accessible_tourism_btn_info[0].classList.add('ocultar');
                accessible_tourism_btn_info_desc = '';

                create_array_for_product('modalities_name', ev.target.value);

                let pick_up_location_name = '', pick_up_location_latitude = '', pick_up_location_longitude = '', pick_up_location_description = '';
                withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'),
                    modality_info(product_type[5], product_type[0], modality_selected),
                    { timeout: 30000 }
                ).then(modality => {
                    // FIX (2026-08-10): guard contra el valor neutro de modality_info (data: null en error).
                    if (!modality || !modality.data || !modality.data[0]) return;
                    create_array_for_product('modality_code', modality.data[0].code);
                    if (modality.description && modality.description !== '') {
                        accessible_tourism_btn_info[0].classList.remove('ocultar');
                        accessible_tourism_btn_info_desc = modality.description;
                    }
                    create_array_for_product('calc_amount', modality.calc_amount);
                    create_array_for_product('min_reserv_amount', modality.min);
                    create_array_for_product('max_reserv_amount', modality.max);
                    accessible_tourism_cantidad[0].setAttribute('data-min', modality.min);
                    accessible_tourism_cantidad[0].setAttribute('data-max', modality.max);

                    if (modality.has_pick_up_locations) {
                        accessible_tourism_pick_up_location.prop('disabled', false).select2({
                            theme: "bootstrap",
                            placeholder: I18n.t('global.main.form.select_pick_up_location'),
                            ajax: {
                                url: `${location.origin}/${sessionStorage.getItem('locale')}/modalities/pick_up_location`,
                                dataType: "json",
                                language: "es",
                                data: function (params) {
                                    return {
                                        search: params.term,
                                        product_type: form_type_send.val(),
                                        modality: modality.data[0].id
                                    };
                                },
                                type: 'GET',
                                processResults: function (data) {
                                    const result = (data.rows || []).map(elem => ({ id: elem, text: elem }));
                                    return { results: result };
                                }
                            }
                        }).on('change', function (e) {
                            const pick_up_location_selected = e.target.value;
                            withElementBlock('box-form', I18n.t('global.main.form.message.loading_data'),
                                pick_up_location_info(pick_up_location_selected),
                                { timeout: 30000 }
                            ).then(pick_up_location => {
                                if (pick_up_location.success) {
                                    pick_up_location_name = pick_up_location.data.name;
                                    pick_up_location_latitude = pick_up_location.data.latitude;
                                    pick_up_location_longitude = pick_up_location.data.longitude;
                                    pick_up_location_description = pick_up_location.data.description;
                                    if (pick_up_location_latitude !== '' && pick_up_location_longitude !== '') {
                                        accessible_tpul_btn[0].classList.remove('ocultar');
                                    } else {
                                        accessible_tpul_btn[0].classList.add('ocultar');
                                    }
                                }
                            });
                        });
                    }
                });

                accessible_tpul_btn.off('click').on('click', function () {
                    showMapModal(pick_up_location_latitude, pick_up_location_longitude, {
                        title: 'Ubicación del punto de recogida',
                        markerText: pick_up_location_name,
                        description: pick_up_location_description
                    }).then(() => {});
                });

                flatpickr(accessible_tourism_date, {
                    altInput: true,
                    altFormat: "d-m-Y",
                    dateFormat: "Y-m-d",
                    disable: date_disabled,
                    minDate: new Date().fp_incr(parseInt(reservation_offset) || 0),
                    maxDate: new Date().fp_incr(90),
                    locale: flatpick_lang
                });

                accessible_tourism_date.off('change').on('change', function (ev) {
                    setSessionVar('from_date', ev.target.value, 'add', true, false).then(from => {
                        create_array_for_product('from_date', from.value);
                    });
                    setSessionVar('to_date', ev.target.value, 'add', true, false, 1).then(to => {
                        create_array_for_product('to_date', to.value);
                    });
                });

                accessible_tourism_btn_info.off('click').on('click', function () {
                    showDescriptionModal(`Descripción de ${create_array_for_product('modalities_name', '', 'show')}`, accessible_tourism_btn_info_desc);
                });
            });
        });
    });
}



/* Antes de dividir */
/*let accessible_tourism_to, accessible_tourism_service, accessible_tourism_modality,
    accessible_tourism_pick_up_location, accessible_tpul_btn,
    accessible_tourism_date, accessible_tourism_cantidad, accessible_tourism_observaciones,
    accessible_tourism_btn_info, accessible_tourism_btn_info_desc;
accessible_tourism_to = $('#accessible_tourism_to');
accessible_tourism_service = $('#accessible_tourism_service');
accessible_tourism_modality = $('#accessible_tourism_modality');
accessible_tourism_pick_up_location = $('#accessible_tourism_pick_up_location');
accessible_tpul_btn = $('#accessible_tpul_btn');
accessible_tourism_date = $('#accessible_tourism_date');
accessible_tourism_cantidad = $('#accessible_tourism_cantidad');
accessible_tourism_observaciones = $('#accessible_tourism_observaciones');
accessible_tourism_btn_info = $('#accessible_tourism_btn_info');
accessible_tourism_service.prop('disabled', true).select2({
    theme: 'bootstrap',
    placeholder: I18n.t('global.main.form.select_service')
});
accessible_tourism_modality.prop('disabled', true).select2({
    theme: 'bootstrap',
    placeholder: I18n.t('global.main.form.select_modality')
});
accessible_tourism_pick_up_location.prop('disabled', true).select2({
    theme: 'bootstrap',
    placeholder: I18n.t('global.main.form.select_pick_up_location')
});
accessible_tourism_date.prop('disabled', true);
accessible_tourism_cantidad.prop('disabled', true);
accessible_tourism_observaciones.prop('disabled', true);

accessible_tourism_to.select2({
    theme: "bootstrap",
    placeholder: I18n.t('global.main.form.select_destiny'),
    ajax: {
        url: '/destination',
        dataType: "json",
        language: "es",
        data: function (params) {
            return {
                form_type: form_type_send.val(),
                search: params.term,
                page: params.page || 1
            }
        },
        type: 'GET',
        processResults: function (data, params) {
            let result = [];
            params.page = params.page || 1;

            data.rows.map((elem, key) => {
                result.push({
                    id: elem.code + '|' + elem.id + '|' + elem.name,
                    text: elem.name
                })
            })

            if (data.total > 10) {
                if ((parseInt(data.total) - (10 * parseInt(params.page))) > 1) {
                    return {
                        results: result,
                        "pagination": {
                            "more": true
                        }
                    }
                } else {
                    return {
                        results: result,
                        "pagination": {
                            "more": false
                        }
                    }
                }
            } else {
                return {
                    results: result,
                    "pagination": {
                        "more": false
                    }
                }
            }
        }
    }
}).on('change', function (e) {
    accessible_tpul_btn[0].classList.add('ocultar');

    let data_accessible_tourism_to = e.target.value.split("|")[1];
    create_array_for_product('product_type', form_type_send.val());
    create_array_for_product('destination_id', e.target.value.split("|")[1]);
    create_array_for_product('destination_code', e.target.value.split("|")[0]);
    create_array_for_product('text_destination', e.target.value.split("|")[2]);

    accessible_tourism_service.empty();
    accessible_tourism_modality.empty();
    accessible_tourism_pick_up_location.empty();
    accessible_tourism_date.empty();
    accessible_tourism_cantidad.empty();
    accessible_tourism_observaciones.empty();
    accessible_tourism_btn_info[0].classList.add('ocultar');
    accessible_tourism_btn_info_desc = '';

    accessible_tourism_service.prop('disabled', false).select2({
        theme: "bootstrap",
        placeholder: I18n.t('global.main.form.select_service'),
        ajax: {
            url: `${location.origin}/${sessionStorage.getItem('locale')}/service_by_dealer`,
            data: function (params) {
                return {
                    search: params.term,
                    page: params.page || 1,
                    destination: data_accessible_tourism_to,
                    form_type: form_type_send.val()
                }
            },
            type: 'GET',
            processResults: function (data, params) {
                let result = [];
                params.page = params.page || 1;
                data.services.map((elem, key) => {
                    result.push({
                        id: elem.id + "|" + elem.code + "|" + elem.reservation_time + "|" + data.dealer_code + "|" + data.dealer_name + "|" + data.dealer_id + "|" + elem.min_reservation_amount + "|" + elem.max_reservation_amount,
                        text: elem.name
                    })
                })

                if (data.total > 10) {
                    if ((parseInt(data.total) - (10 * parseInt(params.page))) > 1) {
                        return {
                            results: result,
                            "pagination": {
                                "more": true
                            }
                        }
                    } else {
                        return {
                            results: result,
                            "pagination": {
                                "more": false
                            }
                        }
                    }
                } else {
                    return {
                        results: result,
                        "pagination": {
                            "more": false
                        }
                    }
                }
            }
        }
    }).on('change', function (e) {
        accessible_tourism_pick_up_location.prop('disabled', false);
        accessible_tourism_date.prop('disabled', false);
        accessible_tourism_cantidad.prop('disabled', false);
        accessible_tourism_observaciones.prop('disabled', false);
        accessible_tourism_btn_info[0].classList.add('ocultar');
        accessible_tourism_btn_info_desc = '';

        let product_type = e.target.value.split("|");
        let product_name = '';
        product_name = e.target.selectedOptions[0].innerHTML.toLowerCase();

        create_array_for_product('category_id', product_type[0]);
        create_array_for_product('category_code', product_type[1]);
        create_array_for_product('dealer_code', product_type[3]);
        create_array_for_product('dealer_name', product_type[4]);
        create_array_for_product('dealer_id', product_type[5]);

        get_contract().then(
            contract => {
                // console.log(contract);
            }
        )

        /!*modalities(product_type[0], product_type[5]).then(
            mdlt => {
                /!* REVISAR LUEGO POR EL TEMA DEL NOMBRE DE LA MODALIDAD ESTA PUESTO 'FINCA EL FRUTAL POR PAX' *!/
                let modalities_name = mdlt.rows[0];
                let split_modality = modalities_name.split(' ');
                if (split_modality[split_modality.length - 1] === 'POR') {
                    modalities_name = split_modality.slice(0, -1).join(' ');
                }
                create_array_for_product('modalities_name', modalities_name);

                modality_info(product_type[5], product_type[0], modalities_name).then(
                    modality => {
                        create_array_for_product('modality_code', modality.data[0].code);
                        create_array_for_product('calc_amount', modality.calc_amount);

                        accessible_tourism_cantidad[0].setAttribute('data-min', modality.min);
                        accessible_tourism_cantidad[0].setAttribute('data-max', modality.max + 20);

                        if (modality.info === 'true') {
                            if (modality.has_pax) {
                                /!* OCULTANDO Y MOSTRANDO INPUTS EN DEPENDENCIA DE LO QUE NOS DEVUELVA EL SERVICIO *!/
                                /!* excursion_pax_block[0].classList.add('ocultar');
                                 excursion_cantidad_block[0].classList.add('ocultar');
                                 excursion_adult_childrens[0].classList.remove('ocultar');*!/

                                /!* SETEANDO ATRIBUTOS A LOS INPUTS PARA EVALUAR *!/
                                /!*excursion_adultos[0].setAttribute('data-min', modality.min);
                                let min = 1;
                                if ((parseInt(modality.min) - 1) <= 0) {
                                    min = 0
                                }
                                excursion_childrens[0].setAttribute('data-min', min)
                                excursion_adultos[0].setAttribute('data-max', modality.max);
                                excursion_childrens[0].setAttribute('data-max', (parseInt(modality.max) - 1))
                                excursion_adultos[0].setAttribute('data-evaluate-max', modality.max);
                                excursion_childrens[0].setAttribute('data-evaluate-max', modality.max)

                                create_array_for_product('day_min_rent', min);
                                create_array_for_product('day_max_rent', modality.max);*!/
                            } else {
                                /!*excursion_pax_block[0].classList.remove('ocultar');
                                excursion_cantidad_block[0].classList.add('ocultar');
                                excursion_adult_childrens[0].classList.add('ocultar');
                                excursion_pax.prop('disabled', false);*!/
                            }
                        }
                    }
                )
            }
        )*!/

        /!* BUSCAR MODALIDADES DADO UN DEALER Y UN PRODUCTO *!/
        let modality_selected = '';
        accessible_tourism_modality.prop('disabled', false).select2({
            theme: "bootstrap",
            placeholder: I18n.t('global.main.form.select_modality'),
            ajax: {
                url: `${location.origin}/${sessionStorage.getItem('locale')}/modalities`,
                dataType: "json",
                language: "es",
                data: function (params) {
                    return {
                        search: params.term,
                        /!*page: params.page || 1,*!/
                        product: product_type[0],
                        dealer: product_type[5]
                    }
                },
                type: 'GET',
                processResults: function (data, params) {
                    let result = [];
                    /!*params.page = params.page || 1;*!/
                    data.rows.map((elem, key) => {
                        result.push({
                            id: elem,
                            text: elem
                        })
                    })

                    return {
                        results: result
                    }
                }
            }
        }).on('change', function (e) {
            modality_selected = e.target.value;

            accessible_tpul_btn[0].classList.add('ocultar');
            accessible_tourism_pick_up_location.empty();
            accessible_tourism_pick_up_location.prop('disabled', false);
            accessible_tourism_btn_info[0].classList.add('ocultar');
            accessible_tourism_btn_info_desc = '';

            create_array_for_product('modalities_name', e.target.value);

            let pick_up_location_name, pick_up_location_latitude, pick_up_location_longitude, pick_up_location_description;
            modality_info(product_type[5], product_type[0], modality_selected).then(
                modality => {
                    create_array_for_product('modality_code', modality.data[0].code);
                    if (modality.description !== '') {
                        accessible_tourism_btn_info[0].classList.remove('ocultar');
                        accessible_tourism_btn_info_desc = modality.description;
                    }
                    create_array_for_product('calc_amount', modality.calc_amount);
                    create_array_for_product('min_reserv_amount', modality.min);
                    create_array_for_product('max_reserv_amount', modality.max);
                    accessible_tourism_cantidad[0].setAttribute('data-min', modality.min)
                    /!*if(modality.max === 0) {
                        accessible_tourism_cantidad[0].setAttribute('data-max', 30);
                    } else {*!/
                    accessible_tourism_cantidad[0].setAttribute('data-max', modality.max);
                    /!*}*!/

                    if (modality.has_pick_up_locations) {
                        accessible_tourism_pick_up_location.prop('disabled', false).select2({
                            theme: "bootstrap",
                            placeholder: I18n.t('global.main.form.select_pick_up_location'),
                            ajax: {
                                url: `${location.origin}/${sessionStorage.getItem('locale')}/modalities/pick_up_location`,
                                dataType: "json",
                                language: "es",
                                data: function (params) {
                                    return {
                                        search: params.term,
                                        product_type: form_type_send.val(),
                                        modality: modality.data[0].id
                                    }
                                },
                                type: 'GET',
                                processResults: function (data, params) {
                                    let result = [];
                                    /!*params.page = params.page || 1;*!/
                                    data.rows.map((elem, key) => {
                                        result.push({
                                            id: elem,
                                            text: elem
                                        })
                                    })
                                    return {
                                        results: result
                                    }
                                }
                            }
                        }).on('change', function (e) {
                            let pick_up_location_selected;
                            pick_up_location_selected = e.target.value;

                            pick_up_location_info(pick_up_location_selected).then(
                                pick_up_location => {
                                    if (pick_up_location.success) {
                                        pick_up_location_name = pick_up_location.data.name;
                                        pick_up_location_latitude = pick_up_location.data.latitude;
                                        pick_up_location_longitude = pick_up_location.data.longitude;
                                        pick_up_location_description = pick_up_location.data.description;

                                        if (pick_up_location_latitude !== '' && pick_up_location_longitude !== '') {
                                            accessible_tpul_btn[0].classList.remove('ocultar');
                                        } else {
                                            accessible_tpul_btn[0].classList.add('ocultar');
                                        }
                                    }
                                }
                            )
                        })
                    }
                }
            )

            accessible_tpul_btn.on('click', function (e) {
                showMapModal(pick_up_location_latitude, pick_up_location_longitude, {
                    title: 'Ubicación del punto de recogida',
                    markerText: pick_up_location_name,
                    description: pick_up_location_description
                }).then(r => {
                });
            })

            flatpickr(accessible_tourism_date, {
                altInput: true,
                altFormat: "d-m-Y",
                dateFormat: "Y-m-d",
                disable: date_disabled,
                minDate: new Date().fp_incr(parseInt(product_type[2]) || 0),
                maxDate: new Date().fp_incr(90),
                locale: flatpick_lang
            });

            accessible_tourism_date.on('change', function (e) {
                /!* SETEANDO FECHA EN QUE EMPIEZA Y TERMINA LA EXCURSION *!/
                setSessionVar('from_date', e.target.value, 'add', true, false).then(
                    from => {
                        create_array_for_product('from_date', from.value);
                    }
                );
                setSessionVar('to_date', e.target.value, 'add', true, false, 1).then(
                    to => {
                        create_array_for_product('to_date', to.value);
                    }
                );
            });

            accessible_tourism_btn_info.on('click', function () {
                showDescriptionModal(`Descripción de ${create_array_for_product('modalities_name', '', 'show')}`, accessible_tourism_btn_info_desc)
            })
        })
    })
})*/
